// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3CHDu","clinicsSelect":"styles_clinicsSelect__PyB7f"};